import { z } from "zod";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

type Translate = (key: string, options?: Record<string, unknown>) => string;

export const L_GENERAL_INFO = `${DRYBULK_CARGO_OPS_LANG_BASE}.detail.final-report.modify`;

export const GENERAL_INFO_FIELDS = {
  WATER_CONSUMPTION: "waterConsumption",
  MAX_FEED_RATE: "maxFeedRate",
} as const;

const WATER_PATTERN = /^\d{1,11}(\.\d{1,3})?$/;
const FEED_RATE_PATTERN = /^\d{1,9}$/;

/** Mirrors the server: m3 above zero with at most 3 decimals, MT/hour a whole number above zero, both required. */
export const generalInfoSchema = (t: Translate) =>
  z.object({
    [GENERAL_INFO_FIELDS.WATER_CONSUMPTION]: z
      .string()
      .trim()
      .min(1, t("form-validation.mandatory", { label: t(`${L_GENERAL_INFO}.fields.water`) }))
      .refine(
        (value) => value === "" || (WATER_PATTERN.test(value) && Number(value) > 0),
        t(`${L_GENERAL_INFO}.errors.water`),
      ),
    [GENERAL_INFO_FIELDS.MAX_FEED_RATE]: z
      .string()
      .trim()
      .min(1, t("form-validation.mandatory", { label: t(`${L_GENERAL_INFO}.fields.feed-rate`) }))
      .refine(
        (value) => value === "" || (FEED_RATE_PATTERN.test(value) && Number(value) > 0),
        t(`${L_GENERAL_INFO}.errors.feed-rate`),
      ),
  });

export type GeneralInfoFormData = z.infer<ReturnType<typeof generalInfoSchema>>;

export const generalInfoDefaultValues: GeneralInfoFormData = {
  waterConsumption: "",
  maxFeedRate: "",
};
